import AuthService from "../../service";

const venueHire = {
  getVenueHire(page, search, sort_date) {
    return AuthService.get(`/service/venue_hire?` +
      `page=${page}` +
      `&sort_date=${sort_date}` +
      `&search=${search}`
    );
  },
  showVenueHire(id) {
    return AuthService.get("/service/venue_hire/" + id);
  },
  createVenueHire(data) {
    return AuthService.post("/service/venue_hire", data);
  },
  updateVenueHire(id, data) {
    return AuthService.put("/service/venue_hire/" + id, data);
  },
  deleteVenueHire(id) {
    return AuthService.delete("/service/venue_hire/" + id);
  },
  getVenueHireAll() {
    return AuthService.get("/service/get_venue_hire_all");
  },
  getVenueHireType() {
    return AuthService.get("/service/get_venue_hire_type");
  }
};
export default venueHire;
